import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Dodajemo navigaciju
import { supabase } from "../../supabaseClient"; // Import klijenta za logout
import AdminBottomNavigation from "./AdminBottomNavigation";
import AdminStartMatch from "./AdminStartMatch";
import AdminRaspored from "./AdminRaspored";
import AdminResultsEdit from "./AdminResultsEdit";
import AdminAddTeams from "./AdminAddTeams";
import MNTLogo from "../../Assets/Images/mnt-podsused-logo.png";
import AdminChampionship from "./AdminChampionship";
import AdminSettings from "./AdminSettings";

const AdminHome = () => {
  const [adminTab, setAdminTab] = useState("dashboard");
  const [activeAction, setActiveAction] = useState("start");
  const [settingsPage, setSettingsPage] = useState("menu");
  const navigate = useNavigate();

  // Funkcija za odjavu
  const handleLogout = async () => {
    const confirmLogout = window.confirm(
      "Jeste li sigurni da se želite odjaviti?",
    );
    if (confirmLogout) {
      const { error } = await supabase.auth.signOut();
      if (error) {
        alert("Greška pri odjavi: " + error.message);
      } else {
        // App.js će reagirati na onAuthStateChange i prebaciti te na login,
        // ali za svaki slučaj radimo manualni redirect
        navigate("/admin-login");
      }
    }
  };

  const renderContent = () => {
    if (adminTab === "dashboard") {
      switch (activeAction) {
        case "start":
          return <AdminStartMatch />;
        case "results":
          return <AdminResultsEdit />;
        case "schedule":
          return <AdminRaspored />;
        case "teams":
          return <AdminAddTeams />;
        default:
          return <AdminStartMatch />;
      }
    }

    if (adminTab === "bracket") {
      return <AdminChampionship />;
    }

    if (adminTab === "settings") {
      return (
        <AdminSettings
          settingsPage={settingsPage}
          setSettingsPage={setSettingsPage}
        />
      );
    }
  };

  return (
    <div className="admin-wrapper">
      <div className="admin-fixed-header">
        <div className="admin-navigation">
          <a href="/admin-panel">
            <img className="logo" src={MNTLogo} alt="Logo" />
          </a>
          <h1 className="title">ADMIN</h1>
          {/* Implementirana onClick funkcija */}
          <button className="logout-btn" onClick={handleLogout}>
            Odjavi se
          </button>
        </div>

        {adminTab === "dashboard" && (
          <div className="admin-top-nav">
            <button
              className={activeAction === "start" ? "active" : ""}
              onClick={() => setActiveAction("start")}
            >
              Pokreni Utakmicu
            </button>
            <button
              className={activeAction === "results" ? "active" : ""}
              onClick={() => setActiveAction("results")}
            >
              Uredi Rezultate
            </button>{" "}
            <button
              className={activeAction === "schedule" ? "active" : ""}
              onClick={() => setActiveAction("schedule")}
            >
              Uredi Raspored
            </button>
            <button
              className={activeAction === "teams" ? "active" : ""}
              onClick={() => setActiveAction("teams")}
            >
              Uredi Grupe
            </button>
          </div>
        )}
      </div>

      <div className="admin-content-scrollable">{renderContent()}</div>

      <AdminBottomNavigation
        adminTab={adminTab}
        setAdminTab={(tab) => {
          setAdminTab(tab);
          if (tab === "settings") setSettingsPage("menu");
        }}
      />
    </div>
  );
};

export default AdminHome;
